export default function History() {
  return <h1 style={{ color: 'white' }}>History Page</h1>;
}
